import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import failedImg from '../../../assets/images/error.svg'
import Button from '../../../components/Button'
import { useAppContext } from '../../../context/AppContext'
import { useStepsContext } from '../../../context/StepsContext'
import { procedureComplete } from '../../../redux/actions'

const PrepagaFailed = () => {
  const { setBlockNavigation }: any = useAppContext()
  const history = useHistory()

  const dispatch = useDispatch()
  const { resetSteps }: any = useStepsContext()

  const onContinue = () => {
    dispatch(procedureComplete())
    resetSteps()
    history.push('/procedures/activaciones')
    setBlockNavigation(false)
  }

  return (
    <main className="landing">
      <div className="landing-container">
        <img src={failedImg} alt="activation failed" style={{ height: '150px' }} />
        <h3>
          <strong>
            Algo salió mal <br /> El chip no pudo ser activado
          </strong>
        </h3>
        <p className="error-sugest">
          Por favor reportá el caso enviando un sms al 7767 desde cualquier línea Claro o al 0994 401 111
        </p>
        <Button
          id="prepaga-failed-back-to-start"
          className="link-button"
          label="Ir al Inicio"
          handleSubmit={onContinue}
        />
      </div>
    </main>
  )
}

export default PrepagaFailed
